import React, {ReactChildren, ReactNode, useEffect} from 'react'
import {Login} from "../../pages/login/Login";
import {Aside} from "../aside/Aside";
import {DownSidebar} from "../downSidebar/DownSidebar";
import {WrapperLogin} from "./components/WrapperLogin";
import {WrapperSidebar} from "./components/WrapperSidebar";

interface IWrapperProps {
    children: ReactNode
}

// Screens that stand on their own, with no sidebar or navigation. The
// change-password screen belongs here for the same reason as login: while a
// forced change is pending there is nowhere else to go.
const BARE_SCREENS = ['login', 'reset-password', 'change-password']

const isBareScreen = () =>
    BARE_SCREENS.some(screen => window.location.href.includes(screen))


export const Wrapper: React.FC<IWrapperProps> = ({children}) => {

    return (
        <>
            {
                isBareScreen() ? <WrapperLogin children={children}/> : <WrapperSidebar children={children}/>
            }
        </>
    )
}
